export default __webpack_public_path__ + "static/media/NIAS0480.34I-43123_-25787_0.c15406eb.jpg";